export default __webpack_public_path__ + "64f2264b1f5333641fcbd934f91355c5.png";